import { render } from "./form-validation.vue?vue&type=template&id=60e5cc52"
import script from "./form-validation.vue?vue&type=script&lang=js"
export * from "./form-validation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__